<template>
  <!-- App root: flex layout with dark mode support -->
  <div
    class="relative flex flex-col min-h-full overflow-y-auto"
    :class="{
      'dark bg-tl-grey-100': darkMode,
      'bg-white': !darkMode,
    }"
  >
    <SiteHeader class="absolute top-0 left-0 z-20" @show-login="showLoginDialog = true" />
    <RouterView class="flex grow flex-col" />

    <!-- User Authentication Dialogs -->
    <MemorablePasswordDialog
      v-model="showMemorablePasswordDialog"
      :memorable-password="memorablePassword"
    />
    <LoginDialog v-model="showLoginDialog" @new-password="newUserCreated" />
  </div>
</template>

<script setup lang="ts">
import useAppStore from '@/composition/appStore'
import { RouterView } from 'vue-router'
import SiteHeader from './components/SiteHeader.vue'
import MemorablePasswordDialog from './components/MemorablePasswordDialog.vue'
import LoginDialog from './components/LoginDialog.vue'
import { ref, onMounted } from 'vue'

const appStore = useAppStore()
const darkMode = appStore.getters.darkMode

const showMemorablePasswordDialog = ref(false)
const showLoginDialog = ref(false)
const memorablePassword = ref('')

onMounted(async () => {
  // Try to load an existing user
  await appStore.actions.loadUser()
})

function newUserCreated(password: string) {
  memorablePassword.value = password
  showMemorablePasswordDialog.value = true
}
</script>

<style scoped></style>
